import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import * as CSC from "SC";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { AddNewRecipientFlow } from "./AddNewRecipientFlow";

import { useDataGrid } from "hooks/useDataGrid";
import { GlobalContext } from "store/globalContext";
import { DataGrid } from "UI/DataGrid";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";

const columns = [
  {
    label: "Name",
    field: "name",
    xs: 3.5,
    sm: 3.5,
    md: 3.5,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 2.8,
    sm: 2.8,
    md: 2.8,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 1.7,
    sm: 1.7,
    md: 1.7,
  },
  // {
  //   label: "Email",
  //   field: "email",
  //   xs: 2.05,
  //   sm: 2.05,
  //   md: 2.05,
  //   renderer: ({ email }) => (
  //     <TextFieldWithEllipsis>{email}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "City",
    field: "city",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
  },
  {
    label: "State",
    field: "state",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
  },
  {
    label: "ZIP",
    field: "zipCode",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
  },
  {
    label: "Status",
    field: "isBlocked",
    xs: 1,
    sm: 1,
    md: 1,
    align: "center",
    renderer: ({ isBlocked }) =>
      isBlocked ? (
        <Box color="red">Suspended</Box>
      ) : (
        <Box color="green">Active</Box>
      ),
  },
];

const mobileColumns = [
  {
    label: "Name",
    field: "name",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 3,
    sm: 3,
    md: 3,
  },
  {
    label: "Status",
    field: "isBlocked",
    xs: 2,
    sm: 2,
    md: 2,
    align: "center",
    renderer: ({ isBlocked }) =>
      isBlocked ? (
        <Box color="red">Suspended</Box>
      ) : (
        <Box color="green">Active</Box>
      ),
  },
];

export const Recipients = () => {
  const navigate = useNavigate();
  const [isAddNewDialogOpen, setIsAddNewDialogOpen] = useState(false);
  const { userData } = useContext(GlobalContext);

  const dataGrid = useDataGrid({
    url: "/recipients",
    defaultSorter: {
      name: "name",
      order: "asc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Recipients`,
  });

  const handleRowClick = ({ id }) => navigate(`/recipient/${id}`);

  const comment =
    "Organizations or providers receiving patient referrals from Senders.";

  return (
    <CommonOutletTemplate
      title="Recipients"
      comment={comment}
      isLoading={!dataGrid?.rows}
    >
      {isAddNewDialogOpen && (
        <AddNewRecipientFlow
          handleClose={() => setIsAddNewDialogOpen(false)}
          refreshList={() => dataGrid.loadData()}
        />
      )}
      <DataGrid
        columns={columns}
        mobileColumns={mobileColumns}
        handleRowClick={handleRowClick}
        {...dataGrid}
        afterSearchContent={
          <CSC.BlueButton
            variant="outlined"
            onClick={() => setIsAddNewDialogOpen(true)}
          >
            Add New Recipient
          </CSC.BlueButton>
        }
      />
    </CommonOutletTemplate>
  );
};
